'use strict'

// Displays the terms of use link. Link text and url are localized
cpntMap.set('awe-swaven-link', {
  props: {
    wtbid: {type: String},
    touchPoint: {type: String},
    visible: {type: Boolean, default: true}
  },
  computed: {
    url: function(){
      return `https://www.mikmak.com/?utm_source=pop&utm_medium=${this.touchPoint || this.$root.wtbConf.touchPoint}&utm_campaign=${this.wtbid}`
    }
  },
  template: `
    <a v-if="visible" class="swaven-link" title="MikMak" alt="MikMak" :href="url"  target="_blank">
      <img src="https://content.static-swaven.com/img/logos/2023/mikmak-favicon-teal.png" alt="MikMak" height="15" width="15">
    </a>
  `
})
